// addUpdateAssignment — VQE-Edit edit-action: append a `target = value`
// assignment to an `UPDATE … SET …` statement via SR-Edit's
// `add-update-assignment` op. SR-Edit handles comma placement and respects
// existing list separators (e.g. multiline `, b = 2`); this module only
// validates the inputs and delegates to `commitEdit`.
//
// PRD: Ralph/VisualQueryEditorEdit/PRD.md § Slice: Edit — DML edits.

import { commitEdit, type CommitEditCtx, type CommitOutcome } from '../commitEdit';

export async function addUpdateAssignment(
  target: string,
  valueText: string,
  ctx: CommitEditCtx,
): Promise<CommitOutcome> {
  const t = target.trim();
  const v = valueText.trim();
  if (t.length === 0) {
    throw new Error('addUpdateAssignment: target must not be empty');
  }
  if (v.length === 0) {
    throw new Error('addUpdateAssignment: valueText must not be empty');
  }
  return commitEdit(
    { op: 'add-update-assignment', target: t, valueText: v },
    ctx,
  );
}
